import { Divider, Modal, ModalBody } from "@aurem/ui";
import {
  GlobalSearchContextProvider,
  useGlobalSearchContext,
} from "../context";
import { GlobalSearchProviderProps } from "../types";
import { Companies } from "./Companies";
import { Employees } from "./Employees";
import { EmptyState } from "./EmptyState";
import { SearchHeader } from "./Header";
import { LoadingState } from "./LoadingState";
import { RecentSearch } from "./RecentSearch";

const GlobalSearchDialogContent = () => {
  const { query, loading, companies, employees } = useGlobalSearchContext();

  const showDivider = companies.length > 0 && employees.length > 0;
  const hasNoResults =
    query && companies.length === 0 && employees.length === 0;

  return (
    <>
      <SearchHeader />
      <div className="flex flex-col flex-1 gap-2.5 min-h-0 p-2 overflow-auto">
        {loading ? (
          <LoadingState />
        ) : query ? (
          hasNoResults ? (
            <EmptyState variant="noResults" />
          ) : (
            <>
              <Companies />
              {showDivider && <Divider />}
              <Employees />
            </>
          )
        ) : (
          <RecentSearch />
        )}
      </div>
    </>
  );
};

export const GlobalSearchDialog = ({
  open,
  onDismiss,
}: GlobalSearchProviderProps) => {
  return (
    <Modal
      open={open}
      onOpenChange={onDismiss}
      showClose={false}
      className="p-0 h-[calc(100vh-48px)] max-h-[500px] overflow-hidden"
    >
      <ModalBody className="flex flex-col flex-1 min-h-0 p-0 pb-4 overflow-hidden">
        <GlobalSearchContextProvider open={open} onDismiss={onDismiss}>
          <GlobalSearchDialogContent />
        </GlobalSearchContextProvider>
      </ModalBody>
    </Modal>
  );
};
